import ModuleInterface from '../modules.interface';
import seminars from './seminar';

export default [seminars] as ModuleInterface[];
